import { render, staticRenderFns } from "./OurFacilitySwiper.vue?vue&type=template&id=5e937576&scoped=true&"
import script from "./OurFacilitySwiper.vue?vue&type=script&lang=js&"
export * from "./OurFacilitySwiper.vue?vue&type=script&lang=js&"
import style0 from "./OurFacilitySwiper.vue?vue&type=style&index=0&id=5e937576&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5e937576",
  null
  
)

export default component.exports